import { ClientIntakeResponsesState } from './clientIntakeResponses.firebase.state';

export class ClientIntakeResponsesSelectors {
	static readonly _props = ClientIntakeResponsesState._props;

	static readonly $getAllClientIntakeResponses =
		ClientIntakeResponsesState._props.items;
}
